export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12205.fa04a9ed.jpg";